import createVueComponent from '../createVueComponent';

const GitMerge = createVueComponent('GitMergeIcon', [
  ['circle', { cx: '18', cy: '18', r: '3', key: '1xkwt0' }],
  ['circle', { cx: '6', cy: '6', r: '3', key: '1lh9wr' }],
  ['path', { d: 'M6 21V9a9 9 0 0 0 9 9', key: '7kw0sc' }],
]);

export default GitMerge;
